/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

import styles from "./SearchNoResults.module.scss";

const LinkText = dynamic(() => import("components/LinkText"));

const SearchResults = () => {
  const { t } = useTranslation("translations");

  return (
    <section className={styles.noResults}>
      <p className={styles.text}>{t("web_search_no_result_text")}</p>
      <LinkText href={"https://bit.ly/filmønsker"} className={styles.link} bold>
        {t("web_search_add_to_wishlist")}
      </LinkText>
    </section>
  );
};

export default SearchResults;
